/**
 * How the Ask Nova header arranges its view switcher and actions: the Ask-Nova and Insights tabs
 * side by side, one dropdown that shows the current view, or that dropdown with the secondary actions
 * moved into a "more" menu.
 */
export type NovaHeaderLayout = 'tabs' | 'dropdown' | 'overflow';

/** Width of one header action button, in pixels. */
export const NOVA_HEADER_ACTION_WIDTH = 44;

/** The widths, in pixels, that decide the header layout. */
export interface NovaHeaderWidths {
  /** Space inside the header's padding. */
  content: number;
  /** Narrowest width of the two view tabs at which both labels show in full. */
  tabs: number;
  /** Narrowest width of the view dropdown at which its longer label shows in full. */
  dropdown: number;
  /** Width of the actions when each has its own button. */
  actions: number;
  /** Space between the view switcher and the actions. */
  gap: number;
}

/**
 * The roomiest layout that fits: the two tabs, else the view dropdown with every action, else the
 * dropdown with the secondary actions in the "more" menu. Before the header has been measured, when
 * `content` is 0, the tabs are kept.
 */
export function novaHeaderLayout(widths: NovaHeaderWidths): NovaHeaderLayout {
  const { content, tabs, dropdown, actions, gap } = widths;
  if (content <= 0 || tabs + gap + actions <= content) return 'tabs';
  if (dropdown + gap + actions <= content) return 'dropdown';
  return 'overflow';
}
